module.exports = __webpack_public_path__ + "media/images/product-banners/cod-0282d3d7a537834e8dbd60ca2e8d2351.svg";